import { Box, Button } from '@mui/material';
import React, { useState } from 'react';
import RenderHTML from '../../../components/preview/RenderHTML';
import PopUpTextEditor from '../../../components/popup/PopUpTextEditor';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { API_PATCH, DBRequest, useConfig } from '../../../api/api';
import ExoDialog from '../../../components/exo/ExoDialog';
import ExoExplorer from '../../../components/exo/ExoExplorer';

export const SalesObjectLevelImages = ({ images, levelId, onChange }) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [open, setOpen] = useState(false);
  function handleChange(data) {
    setOpen(false);
    DBRequest({
      config,
      path: `sales-object-levels/${levelId}`,
      method: API_PATCH({ images: data }),
      onResponse: onChange,
    });
  }

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        sx={{
          padding: '5px 10px',
          justifyContent: 'start',
          textAlign: 'left',
        }}
        variant="outlined"
        className="w-full"
      >
        {images ? (
          <Box>
            {images.map((img) => (
              <img src={img.temporaryUrl} />
            ))}
          </Box>
        ) : (
          <>
            <AddIcon className="mr-1" />
            {t('Add Images')}
          </>
        )}
      </Button>
      <ExoDialog open={open} onClose={() => setOpen(false)}>
        <ExoExplorer
          onSelect={handleChange}
          multiSelect
          preSelected={images}
          maxItems={20}
          maxSizeKB={9999}
        />
      </ExoDialog>
    </>
  );
};
